import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { GiftUnlockExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { DropdownOption } from '../../../../shared/config/extension-ui-options';
import { GiftUnlockPreviewMode } from '../../gift-unlock.component';
import { GiftUnlockOfferProductComponent } from './components/gift-unlock-offer-product/gift-unlock-offer-product.component';
import { GiftUnlockOfferSellingPlanComponent } from './components/gift-unlock-offer-selling-plan/gift-unlock-offer-selling-plan.component';

@Component({
  selector: 'gift-unlock-offer',
  templateUrl: './gift-unlock-offer.component.html',
  styleUrls: ['./gift-unlock-offer.component.scss'],
  standalone: false,
})
export class GiftUnlockOfferComponent {
  @ViewChild(GiftUnlockOfferProductComponent) offerProduct: GiftUnlockOfferProductComponent;
  @ViewChild(GiftUnlockOfferSellingPlanComponent) offerSellingPlan: GiftUnlockOfferSellingPlanComponent;

  @Input() formGroup: UntypedFormGroup;
  @Input() offerTypeOptions: DropdownOption[];
  @Input() couponTypeOptions: DropdownOption[];
  @Input() shopCurrencySymbol: string;
  @Input() popupActiveTab: string;
  @Input() giftMessageEnabled: boolean;
  @Input() updateRequired: boolean;
  @Input() updateAppUrl: string;
  @Input() activePreviewMode: GiftUnlockPreviewMode;

  @Output() popupTabChange = new EventEmitter<string>();
  @Output() previewToggle = new EventEmitter<void>();

  OfferType = GiftUnlockExtension.OfferType;
  PreviewMode = GiftUnlockPreviewMode;

  get isAutoApplyEnabled(): boolean {
    return !!this.formGroup?.get('settings.productDetails.autoAddToCart')?.value;
  }

  get isInformationProvided(): boolean {
    return !this.giftMessageEnabled || this.popupActiveTab !== 'missingInformationPopup';
  }

  get isSellingPlanProduct(): boolean {
    return this.formGroup?.get('settings.offerType')?.value === GiftUnlockExtension.OfferType.SELLING_PLAN_PRODUCT;
  }

  get isCoupon(): boolean {
    return this.formGroup?.get('settings.offerType')?.value === GiftUnlockExtension.OfferType.COUPON;
  }

  get isLegacyOfferType(): boolean {
    return this.isSellingPlanProduct || this.isCoupon;
  }

  get isOfferPreviewActive(): boolean {
    return (
      this.activePreviewMode === GiftUnlockPreviewMode.GiftOffer ||
      this.activePreviewMode === GiftUnlockPreviewMode.GiftPopup ||
      this.activePreviewMode === GiftUnlockPreviewMode.MissingInfoPopup
    );
  }

  scrollToHideInCartLevel(): void {
    (this.offerProduct ?? this.offerSellingPlan)?.scrollToHideInCartLevel();
  }

  onPopupTabChange(tab: string): void {
    this.popupTabChange.emit(tab);
  }
}
